module.exports = __webpack_public_path__ + "static/media/ellipse.eb69ffbd.png";